import { useEffect, useState } from 'react';
import { KB_LOG_EVENT, kbLogLines } from './hooks';

/**
 * `?kb=debug`: what the keyboard and the viewport are doing, live, so a jump
 * that only happens on a real phone can be screenshotted and read. Off unless
 * asked for in the address.
 */
export function KbDebug() {
  const [on] = useState(() => {
    try {
      return new URLSearchParams(location.search).get('kb') === 'debug';
    } catch {
      return false;
    }
  });
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!on) return;
    const bump = () => setTick((n) => n + 1);
    window.addEventListener(KB_LOG_EVENT, bump);
    window.visualViewport?.addEventListener('resize', bump);
    window.visualViewport?.addEventListener('scroll', bump);
    return () => {
      window.removeEventListener(KB_LOG_EVENT, bump);
      window.visualViewport?.removeEventListener('resize', bump);
      window.visualViewport?.removeEventListener('scroll', bump);
    };
  }, [on]);
  if (!on) return null;
  const vv = window.visualViewport;
  const shell = document.querySelector('.screen.shell');
  const style = shell ? getComputedStyle(shell) : null;
  const root = document.documentElement;
  return (
    <pre
      aria-hidden
      style={{
        position: 'fixed',
        top: 'calc(var(--safe-top) + 4px)',
        right: 4,
        zIndex: 999,
        margin: 0,
        padding: 6,
        maxWidth: '62vw',
        fontSize: 9,
        lineHeight: 1.3,
        background: 'rgba(0,0,0,0.82)',
        color: '#7cff4f',
        borderRadius: 6,
        pointerEvents: 'none',
        whiteSpace: 'pre-wrap',
      }}
    >
      {[
        `mode ${root.dataset.vv ?? '?'} kb ${root.dataset.keyboard ?? '-'} move ${root.dataset.kbmove ?? '-'}`,
        `vv ${Math.round(vv?.height ?? 0)} @${Math.round(vv?.offsetTop ?? 0)} inner ${window.innerHeight} scrollY ${Math.round(window.scrollY)}`,
        `shell h ${style?.height ?? '-'} t ${style?.transform ?? '-'}`,
        '',
        ...kbLogLines(),
      ].join('\n')}
    </pre>
  );
}
